import { HttpInterceptorFn } from '@angular/common/http';

import { joinWithSlash, snakeToCamel } from 'app/helpers';
import { getOauthProviders } from 'app/helpers/config';
import { environment } from 'environments/environment';

export const oauthInterceptor: HttpInterceptorFn = (req, next) => {
    const createSuitableUrls = (): string[] => {
        const urls: string[] = [];
        const oauths = getOauthProviders();
        for (const oauthsKey in oauths) {
            if (oauths.hasOwnProperty(oauthsKey)) {
                urls.push(joinWithSlash(environment.apiUrl, oauths[oauthsKey].url));
            }
        }
        return urls;
    };

    if (createSuitableUrls().indexOf(req.url) === -1) {
        return next(req);
    }

    const body = req.body as any;
    const newBody = { ...body.authorizationData, ...body.oauthData, ...body.userData };
    const fixedNewBody: Record<string, unknown> = {};

    for (const key in newBody) {
        if (newBody.hasOwnProperty(key)) {
            fixedNewBody[snakeToCamel(key)] = newBody[key];
        }
    }

    return next(req.clone({ body: fixedNewBody }));
};
